import { render } from "./InvoiceItem.vue?vue&type=template&id=b85c84b2&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"

import "./InvoiceItem.vue?vue&type=style&index=0&id=b85c84b2&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85c84b2"]])

export default __exports__